import AGREGAR_EXPEDIENTE from '@/graphql/mutations/administracion/expedientes/agregarExpediente.gql';
import ACTUALIZAR_EXPEDIENTE from '@/graphql/mutations/administracion/expedientes/actualizarExpediente.gql';
import REMOVER_EXPEDIENTE from '@/graphql/mutations/administracion/expedientes/removerExpediente.gql';
import EXPEDIENTE_POR_CONTRATO from '@/graphql/querys/administracion/expediente/expedientePorContrato.gql';
import CREAR_EXPEDIENTE from '@/graphql/mutations/administracion/expedientes/crearExpediente.gql';

// const BASE_URL = process.env.NODE_ENV !== 'production'
//   ? 'http://localhost:3001'
//   : 'https://sideop-file-server.hermosillo.gob.mx';

export default {
  methods: {
    mixSetEtapa(etapa) {
      if (etapa === 1) return 'AE';
      if (etapa === 2) return 'EJ';
      if (etapa === 3) return 'DE';
      return 'N/A';
    },
    seleccion() {
      this.rutaArchivo = URL.createObjectURL(
        document.getElementById('anexo').files[0],
      );
      this.nombreArchivoSeleccionado = document.getElementById('anexo').files[0].name;
    },
    // async mixGetPdf(data) {
    //   if (data.publicKey) {
    //     await this.axios.get(
    //       `${BASE_URL}/${data.publicKey}`,
    //       {
    //         responseType: 'blob',
    //         onDownloadProgress: (progressEvent) => {
    //           if (progressEvent.lengthComputable) {
    //             this.progresoDescarga = Math.round(
    //               (progressEvent.loaded * 100) / progressEvent.total,
    //             );
    //           }
    //         },
    //       },
    //     )
    //       .then((res) => {
    //         this.archivoDescarga = res.data;
    //         this.rutaArchivo = URL.createObjectURL(new Blob([res.data], {
    //           type: 'application/pdf',
    //         }));
    //       })
    //       .catch((err) => {
    //         this.mixMensajeError(err.data.message);
    //       });
    //   }
    // },
    async mixCrearExpediente() {
      const expedienteDocumentos = this.documentosSeleccionados.map(({ id, orden }) => ({
        idDocumento: id,
        orden,
        idContrato: this.idReferencia,
        aplica: true,
        referencia: '',
      }));

      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: CREAR_EXPEDIENTE,
          variables: {
            expediente: expedienteDocumentos,
          },
          update: (store, { data: { crearExpediente } }) => {
            const query = {
              query: EXPEDIENTE_POR_CONTRATO,
              variables: {
                idContrato: this.idReferencia,
              },
            };
            const { expedientePorContrato } = store.readQuery(query);
            const expedientePorContratoCopia = expedientePorContrato.slice();
            expedientePorContratoCopia.push(...crearExpediente);
            store.writeQuery({
              ...query,
              data: {
                expedientePorContrato: expedientePorContratoCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Agregar Expediente
    async mixAgregarExpediente() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_EXPEDIENTE,
          variables: {
            expediente: this.expediente,
          },
          update: (store, { data: { agregarExpediente } }) => {
            const query = {
              query: EXPEDIENTE_POR_CONTRATO,
              variables: {
                idContrato: this.idReferencia,
              },
            };
            const { expedientePorContrato } = store.readQuery(query);
            const expedientePorContratoCopia = expedientePorContrato.slice();
            expedientePorContratoCopia.push(agregarExpediente);
            store.writeQuery({
              ...query,
              data: {
                expedientePorContrato: expedientePorContratoCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    // Actualizar Expediente
    async mixActualizarExpediente() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_EXPEDIENTE,
          variables: {
            id: this.expedienteDocumentoEditar.id,
            expediente: this.expediente,
          },
          update: (store, { data: { actualizarExpediente } }) => {
            const query = {
              query: EXPEDIENTE_POR_CONTRATO,
              variables: {
                idContrato: this.expedienteDocumentoEditar.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { expedientePorContrato } = data;
            const index = expedientePorContrato
              .findIndex((expedienteDocumento) => expedienteDocumento.id
                === actualizarExpediente.id);
            if (index !== -1) {
              expedientePorContrato.splice(index, 1, actualizarExpediente);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    // Eliminar Expediente
    async mixEliminarDocumentoExpediente() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_EXPEDIENTE,
        variables: {
          id: this.documentoExpedienteEliminar.id,
        },
        update: (store) => {
          const query = {
            query: EXPEDIENTE_POR_CONTRATO,
            variables: {
              idContrato: this.documentoExpedienteEliminar.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { expedientePorContrato } = data;
          const index = expedientePorContrato
            .findIndex((documentoExpediente) => documentoExpediente.id
            === this.documentoExpedienteEliminar.id);
          if (index !== -1) {
            expedientePorContrato.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
